import { createTestIds } from '../../utils';

export const getThemeSwitcherTestIds = createTestIds('theme-switcher', [] as const);
